import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Logo from '../../assets/icons/logo-denis-didero-dashboard.png';
import { useAuth } from '../../hooks/auth/useAuth';
import { Role } from '../../utils/enums/role.enum';

export function Dashboard() {
  const { authState } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="dashboard__content">
      <img src={Logo} alt="logo" className="dashboard__logo" />
      <h2 className="dashboard__title">{t('DASHBOARD.WELCOME_TITLE')}</h2>
      <p>{t('DASHBOARD.WELCOME_DESCRIPTION', { name: authState?.name })}</p>

      {authState?.role === Role.Parent && (
        <>
          <section className="dashboard__links__wrapper">
            <h3>{t('DASHBOARD.WHAT_TO_DO')}</h3>
            <ul className="dashboard__links__list">
              <li>
                <Link className="dashboard__link" to="profile">
                  {t('DASHBOARD.NAVIGATION.PROFILE.TITLE')}
                </Link>
                <span>: {t('DASHBOARD.NAVIGATION.PROFILE.DESCRIPTION')}</span>
              </li>
              <li>
                <Link className="dashboard__link" to="food-management">
                  {t('DASHBOARD.NAVIGATION.FOOD.TITLE')}
                </Link>
                <span>: {t('DASHBOARD.NAVIGATION.FOOD.DESCRIPTION')}</span>
              </li>
              <li>
                <Link className="dashboard__link" to="payments">
                  {t('DASHBOARD.NAVIGATION.PAYMENTS.TITLE')}
                </Link>
                <span>: {t('DASHBOARD.NAVIGATION.PAYMENTS.DESCRIPTION')}</span>
              </li>
              <li>
                <Link className="dashboard__link" to="transportation-plan">
                  {t('DASHBOARD.NAVIGATION.TRANSPORTATION.TITLE')}
                </Link>
                <span>
                  : {t('DASHBOARD.NAVIGATION.TRANSPORTATION.DESCRIPTION')}
                </span>
              </li>
              <li>
                <Link className="dashboard__link" to="term-reports">
                  {t('DASHBOARD.NAVIGATION.TERM_REPORTS.TITLE')}
                </Link>
                <span>
                  : {t('DASHBOARD.NAVIGATION.TERM_REPORTS.DESCRIPTION')}
                </span>
              </li>
            </ul>
          </section>
          <p>
            {t('DASHBOARD.CONTACT_US')} {t('DASHBOARD.THANK_YOU')}
          </p>
          <p>{t('DASHBOARD.WISHES')}</p>
        </>
      )}
    </div>
  );
}
